<template>
    <v-container>
        <div>
            <v-flex>
                <v-row>
                    <h1 class="page-title">News Feed</h1>
                    <v-spacer class="line"></v-spacer>
                    <hr>
                    <new-post-modal :postsList="postsList"></new-post-modal>
                </v-row>
            </v-flex>

            <v-flex
                    class="mt-3"
            >
                <v-layout row>

                    <v-expansion-panels>

                        <v-expansion-panel
                                v-for="post of postsSearchedPaged"
                                :key="post.id"
                                class="col-sm-12 mb-2"
                                :disabled="localLoading"
                        >
                            <div class="post-actions float-right flex-column d-flex pl-2">
                                <edit-post-modal :thisPostData="post" :editPost="editPost"></edit-post-modal>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                                @click="deleteItem(post)"
                                                x-small
                                                icon
                                                color="grey lighten-1"
                                                v-on="on"
                                        >
                                            <v-icon style="font-size: 20px;">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Delete</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                                @click="onChangeStatus(post)"
                                                x-small
                                                icon
                                                color="grey lighten-1"
                                                v-on="on"
                                        >
                                            <v-icon style="font-size: 20px;" v-if="post.status == STATUS_SHOW">mdi-eye</v-icon>
                                            <v-icon style="font-size: 20px; color: red;" v-if="post.status == STATUS_HIDE">mdi-eye-off</v-icon>
                                        </v-btn>
                                    </template>
                                    <span v-if="post.status == STATUS_SHOW">Press to Hide</span>
                                    <span v-if="post.status == STATUS_HIDE">Press to Show</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                                @click="onChangePinned(post)"
                                                x-small
                                                icon
                                                color="grey lighten-1"
                                                v-on="on"
                                        >
                                            <v-icon style="font-size: 20px; color: blue;" v-if="post.pinned == PINNED_YES">mdi-pin</v-icon>
                                            <v-icon style="font-size: 20px;" v-if="post.pinned == PINNED_NO">mdi-pin-off</v-icon>
                                        </v-btn>
                                    </template>
                                    <span v-if="post.pinned == PINNED_YES">Press to Pinout</span>
                                    <span v-if="post.pinned == PINNED_NO">Press to Pin</span>
                                </v-tooltip>
                            </div>
                            <v-card-text class="overline text-right mb-0 pb-0">
                                <span class="pr-2">
                                <v-chip
                                    color="red"
                                    text-color="white"
                                    x-small
                                    v-if="post.important == IMPORTANT_YES"
                                >Important!
                                </v-chip>
                                </span>
                                <span class="pr-2">({{post.readedCount}} / {{post.totalReadersCount}} read)</span>
                                <span class="pr-2">{{mysqlTimestampToDate(post.updated_at)}}</span>
                            </v-card-text>
                            <v-card-text class="overline text-right mb-0 pb-0">
                                <span class="pr-2">
                                    Created By: {{post.news_author}}
                                </span>
                            </v-card-text>
                            <v-img
                                    max-width="500px"
                                    max-height="300px"
                                    v-if="post.img !== null"
                                    :src="`${appConfig.app_url}/images/${post.img}`"
                            ></v-img>
                            <v-card-title class="pt-0">{{post.postTitle}}</v-card-title>
                            <v-card-text v-html="post.postContent" class="post-content"></v-card-text>

                            <v-card-actions
                                    class="justify-end"
                            >
                                <v-expansion-panel-header>
                                    <template v-slot:actions>
                                        <v-icon></v-icon>
                                    </template>
                                    <v-btn
                                            small
                                            text
                                            color="primary"
                                    >View Replies
                                    </v-btn>
                                </v-expansion-panel-header>
                                <new-reply-modal :thisPostData="post"></new-reply-modal>
                            </v-card-actions>

                            <v-expansion-panel-content>
                                <div
                                        v-for="reply of post.replies"
                                        :key="reply.id"
                                >
                                    <v-card-text class="overline text-right mb-0 pb-0">
                                        <span>
                                            >by {{reply.reply_author}}
                                        </span>
                                    </v-card-text>
                                    <v-card-text>{{reply.reply_content}}</v-card-text>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                    </v-expansion-panels>

                    <!--  <v-card
                              v-for="post of postsList"
                              :key="post.id"
                              class="col-sm-12 mb-2"
                      >
                          <v-card-text class="overline text-right mb-0 pb-0">
                              <span class="pr-2">{{post.creationDate}}</span>
                              <span v-for="driver of drivers"
                                    :key="driver.id">
                              <span

                                      v-if="driver.id === post.authorId"
                              >by {{driver.firstName}} {{driver.lastName}}</span>
                                  </span>
                          </v-card-text>
                          <v-card-title class="pt-0">{{post.postTitle}}</v-card-title>
                          <v-card-text>{{post.postContent}}</v-card-text>
                          <v-card-actions
                                  class="justify-end"
                          >
                              <v-btn
                                      @click="openReplies"
                                      class="primary"
                              >Replies</v-btn>
                              <v-btn
                                      class="primary"
                              >Reply</v-btn>
                          </v-card-actions>
                      </v-card>-->
                </v-layout>
            </v-flex>
            <v-row>
                <v-col cols="12" sm="2" md="2">
                    <v-flex class="d-flex flex-row">
                        <div style="min-width:75px" class="pt-2">
                            Per page:
                        </div>
                        <v-select
                            :items="per_page_list"
                            label="Solo field"
                            solo
                            dense
                            v-model="per_page"
                            v-on:change="onCangePerPage"
                            hide-details=""
                        ></v-select>
                    </v-flex>
                </v-col>
                <v-col cols="12" sm="8" md="8">
                <v-pagination
                    :value="page"
                    :length="total_pages"
                    :total-visible="10"
                    @input="onChangePage"
                ></v-pagination>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    {{((page - 1) * per_page) + 1}}&nbsp;-&nbsp;{{ ((page * per_page) < postList.length) ? (page * per_page) : postList.length }}&nbsp;of&nbsp;{{postList.length}}
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import Vue from 'vue'
    import moment from 'moment';

    import { STATUS_SHOW, STATUS_HIDE,
             PINNED_YES, PINNED_NO,
             IMPORTANT_YES, IMPORTANT_DEFAULT
           } from '../../store/posts';

    export default {
        name: "NewsFeed",
        data() {
            return {
                dialog: false,
                postsList: [],
                localLoading: false,
                STATUS_SHOW: STATUS_SHOW,
                STATUS_HIDE: STATUS_HIDE,
                PINNED_YES: PINNED_YES,
                PINNED_NO: PINNED_NO,
                IMPORTANT_YES: IMPORTANT_YES,
                IMPORTANT_DEFAULT: IMPORTANT_DEFAULT,
                page: 1,
                per_page: 15,
                per_page_list: [10, 15, 50, 100, 1000],
            }
        },
        created() {
            this.$store.dispatch('fetchPosts');
            this.$store.dispatch('fetchAreas') // fetch data for modal
            this.$store.dispatch('fetchDrivers') // fetch data for modal
            this.$store.dispatch('fetchRestaurants') // fetch data for modal
        },
        computed: {
            ...mapGetters([
                'posts',
                'areas',
                'restaurants',
                'drivers'
            ]),
            postList() {
                return this.posts;
            },
            postsSearchedPaged() {
                let start = this.per_page * (this.page - 1);
                let end = start + this.per_page;
                return this.postList.slice(start, end);
            },
            total_pages() {
                return Math.ceil(this.postList.length / this.per_page);
            },
        },
        methods: {
            editPost(post) {
                Object.keys(this.posts).forEach(key => {
                    if (this.posts[key].id === post.id) {
                        this.posts[key].postTitle = post.postTitle;
                        this.posts[key].postContent = post.postContent;
                    }
                })

            },
            deleteItem(post) {
                if (!confirm('Remove news ' + post.postTitle + '?')) {
                    return; // exit
                }

                this.localLoading = true;

                this.$store.dispatch('deletePost', post)
                    .then(() => {
                    })
                    .catch(error => {
                        if(error && error.response && error.response.data && error.response.data.id) {
                            alert(error.response.data.id[0]);
                        }
                    })
                    .finally(() => {
                        this.localLoading = false;
                    });
            },
            onChangeStatus(post) {
                this.localLoading = true;

                let post_status = STATUS_SHOW;
                if (post.status == STATUS_SHOW) {
                    post_status = STATUS_HIDE;
                }

                this.$store.dispatch('changeStatus', {id: post.id, status: post_status})
                    .then(() => {
                    })
                    .catch(error => {
                        if(error && error.response && error.response.data && error.response.data.id) {
                            alert(error.response.data.id[0]);
                        }
                    }).finally(() => {
                        this.localLoading = false;
                    });
            },
            onChangePinned(post) {
                this.localLoading = true;

                let post_pinned = PINNED_YES;
                if (post.pinned == PINNED_YES) {
                    post_pinned = PINNED_NO;
                }

                this.$store.dispatch('changePinned', {id: post.id, pinned: post_pinned})
                    .then(() => {
                    })
                    .catch(error => {
                        if(error && error.response && error.response.data && error.response.data.id) {
                            alert(error.response.data.id[0]);
                        }
                    })
                    .finally(() => {
                        this.localLoading = false;
                    });
            },
            onChangePage(page) {
                this.page = page;
                window.scrollTo({top: 0, behavior: 'smooth'});
            },
            onCangePerPage() {
                this.page = 1;
            },
            mysqlTimestampToDate(created_at) {
                return moment.utc(created_at, 'YYYY-MM-DD HH:mm:ss').local().format('DD/MM/YYYY HH:mm')
            },
        }
    }
</script>

<style scoped>
</style>

<style>
.v-card__text.post-content p {
    margin-bottom: auto;
    min-height: 16px;
}
</style>
